import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { LandingPage } from "../src/landing/App";
import "../src/landing/landing.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LandingPage />
  </StrictMode>,
);
